import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div id="AboutUsComp" className="AboutUs">
      <div className="videoDiv"></div>
      <div className="aboutUsCont">
        <h1 id="slogan">About Us</h1>
        <p id="aboutUsText" className="intro aboutUsText">
          Welcome to the ND FitnessClub, your fitness destination! Established
          in 2020, we're here to empower you on your wellness journey. Our
          cutting-edge facility, expert trainers, and inclusive community create
          the perfect environment for achieving your fitness goals. From
          personalized training to energizing group classes, we're dedicated to
          your success. Join the ND FitnessClub and be part of a supportive
          family committed to your health and happiness. Your fitness journey
          starts here – let's thrive together!
        </p>
        <div className="addressline">
          <a className="googleMapLink" href="https://maps.app.goo.gl/8bi7W5QQyPAoq9Cb9" target="_blank">
            <img
              id="dropPinimg"
              src={require("../../assets/placeholder.png")}
              alt="Description"
            />
            <p className="address">
              Sco A20, Sector 36 supermarket, Suncity Township 1, Rohtak 124001{" "}
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
